module.exports = __webpack_public_path__ + "media/EY__demo.5034a8d5.mp4";